<template>
  <b-modal
    :id="dialogId"
    :title="title"
    centered
    scrollable
    :content-class="`common-dialog ${contentClass}`"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <div class="">
      <slot name="body" @close="closeModal" />
    </div>

    <template #modal-footer>
      <slot name="footer" :close="closeModal" />
    </template>
  </b-modal>
</template>
<script>
import { simpleModalId } from "@/constants/dialog.js";

export default {
  name: "CommonModal",
  props: {
    contentClass: {
      type: String,
      default: ""
    },
    dialogId: {
      type: String,
      default: simpleModalId
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.dialogId);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .common-dialog {
    width: 644px;

    & header {
      background-color: $gold;
      color: $white;
      font-size: 1.25rem;

      & button {
        color: $white;
        opacity: 1;
      }
    }

    &-body {
      padding: 0 0.5rem 0.75rem;

      &-section {
        margin-bottom: 1rem;

        & button {
          height: 2rem;
          font-size: 12px;
          line-height: 2rem;
          padding-top: 0;
          padding-bottom: 0;
        }

        &-item {
          width: 48%;
        }
      }
    }

    & footer {
      border-top: 1px solid $light-gray-2;
      padding: 28px 24px;
    }
  }
}
</style>
